import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/psf/promoteOrShare/pageContext';

export const PsfPromoteOrShareErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for PsfPromoteOrShare page (error: ${error})`);
};
